import { render } from "./interrail_logo.vue?vue&type=template&id=4f30e589"
const script = {}

import "./interrail_logo.vue?vue&type=style&index=0&id=4f30e589&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__